import { useEffect, useState } from "react";
import { _Countries } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import Select from "react-select";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    countryID: number;
}


export const SelectDepartamentbyCountryID = ({ onChange, label, idSelector, returnType, countryID }: Props) => {

    const { lista, setLista, instance } = useDataBean(_Countries);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (countryID) {
            getLista(countryID);
        } else {
            setLista([]);
        }
    }, [countryID]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDStates === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDStates,
                    label: `${found.DataBeanProperties.StateCode} - ${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = (Country: number) => {
        const props = { IDCountries: Country };
        instance.getStatesCatalogPorPropiedades(props, null)
            .then((resp: any) => setLista(resp))
            .catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDStates,
        label: `${item.DataBeanProperties.StateCode} - ${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label >{label ?? "País"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Estado..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    )
}